module.exports = __webpack_public_path__ + "static/media/backqq.43369c1d.png";